import axios from "axios";
import { CallingApp } from "../utilsfolder/constant";


const GYB_URL = {
  // LOCAL: "https://localhost:7053",
  // UAT:   "https://localhost:7053",
  LOCAL: "https://dev-adminapi.greenyourbills.com",
  UAT:   "https://dev-adminapi.greenyourbills.com",
  PROD:  "https://adminapi.greenyourbills.com",
};

const getCurrentEnv = () => {
  const envVar = (process.env.REACT_APP_ENV || "").toUpperCase().trim();
  if (envVar && GYB_URL[envVar]) return envVar;

  const hostname = window.location.hostname.toLowerCase();
  if (hostname === "localhost")                                  return "LOCAL";
  if (hostname.includes("devadmin") || hostname.includes("dev")) return "UAT";
  return "PROD";
};

const BASE_URL = GYB_URL[getCurrentEnv()];


export const getUserIp = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");

    if (!response.ok) throw new Error(`HTTP error: ${response.status}`);

    const { ip } = await response.json();

    if (ip) sessionStorage.setItem("UserIp", ip);

    return ip;
  } catch (error) {
    console.error("Failed to fetch user IP:", error);
    return null;
  }
};

export const getBrowserInfo = () => {
  const agent = navigator.userAgent.toLowerCase();

  const browsers = [
    { name: "edge",                match: () => agent.includes("edge") },
    { name: "chromium based edge", match: () => agent.includes("edg") },
    { name: "opera",               match: () => agent.includes("opr") && !!window.opr },
    { name: "chrome",              match: () => agent.includes("chrome") && !!window.chrome },
    { name: "ie",                  match: () => agent.includes("trident") },
    { name: "firefox",             match: () => agent.includes("firefox") },
    { name: "safari",              match: () => agent.includes("safari") },
  ];

  const browser = browsers.find(({ match }) => match())?.name ?? "other";
  sessionStorage.setItem("Browser", browser);
  return browser;
};

const buildHeaders = () => {
  const userIp       = sessionStorage.getItem("UserIp")     || "unknown";
  const browserInfo  = sessionStorage.getItem("Browser")    || "unknown";
  const userRoleId   = sessionStorage.getItem("userRoleId") || "";
  const userRoleName = sessionStorage.getItem("role")       || "";
  const userId       = sessionStorage.getItem("userId")     || "";
  const userEmail    = sessionStorage.getItem("userEmail")  || "";
  const userName     = sessionStorage.getItem("username")   || "";

  return {
    Callingapp:   CallingApp,
    UserInfo:     `browser:${browserInfo},ip:${userIp}`,
    UserIp:       userIp,
    UserRoleId:   userRoleId,
    UserRoleName: userRoleName,
    UserId:       userId,
    UserEmail:    userEmail,
    Username:     userName,
    Env:          process.env.REACT_APP_ENV,
  };
};


const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 90000,
  headers: { "Content-Type": "application/json" },
});


apiClient.interceptors.request.use(
  async (config) => {
    if (!sessionStorage.getItem("UserIp"))    await getUserIp();
    if (!sessionStorage.getItem("Browser"))   getBrowserInfo();

    config.headers = {
      ...buildHeaders(),
      ...config.headers,
    };

    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;

    return config;
  },
  (error) => Promise.reject(error)
);


apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error(
      `API Error [${error.config?.url}]:`,
      error.response?.data || error.message
    );

    if (error.response?.status === 401) {
      console.warn("401 Unauthorized - User may need to login again");
    }

    return Promise.reject(error);
  }
);

export const getHeaders = () => buildHeaders();

export default apiClient;